// This file was once generated when you created this area
// but you can edit it freely

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/tracing'

// The Trip tab is the area's default (and, for now, only) tab, so it shares
// the base route — the Fleet Tracing team will introduce a distinct sub-route
// for a Fleet tab when they migrate into this shared area.
export const TracingAreaRoutes = {
  route: baseRoute,
  Trip: {
    route: baseRoute,
  },
}
